export default {
  "sideMenu.theaterDailyShow": "劇場日報表示区分"
};